export class NTArtWithdrawn {
  GetNTAllocatedArticleList: string;
  GetAllocatedArtById: any;
  GetDuedatechange: any;
  UpdateWithdrawnchange: string;

}
